import { apiGet } from "@/lib/http/client";
import type { ExportJobDetail } from "@/types/api";

export async function fetchExportJob(jobId: string) {
  return apiGet<ExportJobDetail>(`/export-jobs/${encodeURIComponent(jobId)}`);
}
